@if(model.data){
@if(!!model.data.isBanner){
<href class="pos-relative"
      [link]="model.data.banner_url">
    <div class="pos-relative">
        <alt-image [mainImage]="getImage()"
                   [style.padding-bottom]="getImageHeightStyle()"
                   class="pos-relative block"
                   [altImage]="getAlternativeImage()"
                   [altText]="model.data.name" />
        <div [ngClass]="isBannerWithTextOverImage() ? 'pos-absolute bottom-0 left-0 right-0 p-a-5' : 'm-t-2'">
            <p
               [ngClass]="[isBannerWithTextOverImage() ? 'h4 col-w' : 'col-1', !isBannerWithTextOverImage() && (client.isS || client.isM) ? 's1' : 'h4']">
                {{model.data.banner_title}}</p>
            <p class="m-t-2 banner-subtitle"
               [ngClass]="[isBannerWithTextOverImage() ? 'col-w' : 'col-1', !isBannerWithTextOverImage() && (client.isS || client.isM) ? 'c1' : '']"
               sizeClass="XL: p1, SM: p2"
               [innerHTML]="model.data.banner_subtitle"></p>
            @if (model.data.banner_url) {
            <p class="m-t-2 underline inline-block"
               style="text-underline-offset: 3px;"
               [ngClass]="[isBannerWithTextOverImage() ? 'col-w b-col-w' : 'col-1 b-col-1', !isBannerWithTextOverImage() && (client.isS || client.isM) ? 'c1' : 'p1']">
                {{model.data.banner_cta | translate}}</p>
            }
        </div>
    </div>
</href>
}
@else {
<div class="left"
     [gtmImpressionTrack]="gtmProductImpression">
    <div class="pos-relative b-col-5"
         [ngClass]="{'b-a': !hideBorder}">
        @if (client.sizeId > 1 || !hasAlternativeImage) {
        <div class="pos-relative alt-image-container"
             (mouseenter)="onMouseEnter()"
             (mouseleave)="onMouseOut()">
            <a [style.padding-bottom]="getImageHeightStyle()"
               class="pos-relative block overflow-hidden"
               [routerLink]="url"
               [klevuTrackCategoryProductClick]="klevuCategoryProductTrackClick"
               [klevuTrackRecommendationsProductClick]="klevuRecommendationsProductClickData"
               [klevuTrackClick]="klevuSearchTrackClick">
                <div [gtmTrackProductClick]="gtmProductClick">
                    <local-shell />
                    <img class="fill"
                         [image]="getImage()"
                         [attr.alt]="name">
                    @if (canPrintAltImage()) {
                    <img class="fill alt-image"
                         [image]="getAlternativeImage()"
                         [attr.alt]="name">
                    }
                    @if (!hideLabels && (labels.length || model.isNew) && !model.data.promotion_banner) {
                    <div class="z-2 pos-absolute bottom-0 right-0">
                        <!-- is new label -->
                        @if (model.isNew) {

                        <!-- in stock label -->
                        @if (currentInStockLabel) {
                        <span class="plp-label col-w s3 m-r-2"
                              [ngStyle]="{'background-color' : currentInStockLabel.color || 'black'}">
                            {{ currentInStockLabel.label }}
                        </span>
                        }
                        <span class="bg-col-11 plp-label col-w s3">
                            {{ 'New In' | translate }}
                        </span>
                        }
                        <!-- default label -->
                        @if (!model.isNew) {
                        @for (label of currentLabels; track label; let isFirst = $first) {
                        <span class="plp-label col-w s3"
                              [class.m-l-2]="!isFirst"
                              [ngStyle]="{'background-color' : label.color || 'black'}">
                            {{label.label}}
                        </span>
                        }
                        }
                    </div>
                    }
                    @if (model?.data?.promotion_banner && klevuTypeId !== 'recsRecentlyViewed') {
                    <div [ngClass]="[
                               client.isS && gridSize === 2 ? 's3' : 'p-t-2 p-b-2 s1',
                               isBlackLabel ? 'bg-col-b' : 'bg-col-6'
                               ]"
                         class="pos-absolute center z-3 bottom-0 left-0 right-0 col-w _promotion-banner-copy"
                         [ngStyle]="client.isS && gridSize === 1 ? {'font-size': '1rem'} : {}">
                        {{model.data.promotion_banner | optionLabel : 'promotion_banner'}}
                    </div>
                    }
                </div>
            </a>
            @if(!hideWishlist) {
            <product-wishlist-toggle [productId]="wishlistId"
                                     [small]="smallWishlist"
                                     class="pos-absolute z-4 top-2 right-2">
            </product-wishlist-toggle>
            }
        </div>
        }
        @if ((client.isS || client.isM) && hasAlternativeImage){
        <div class="pos-relative overflow-hidden"
             [style.padding-bottom]="getImageHeightStyle()">
            <div class="fill z-2"
                 style="opacity: 1; transition: opacity 0.2s ease;"
                 [ngStyle]="{'opacity' : showBaseImage ? '1' : '0'}"
                 [class.pe-none]="!showBaseImage"
                 (click)="toggleImages(false)">
                <local-shell />
                <img class="fill"
                     [image]="getImage()">
            </div>
            <a [routerLink]="url"
               style="opacity: 1; transition: opacity 0.2s ease;"
               [ngStyle]="{'opacity' : !showBaseImage ? '1' : '0'}"
               class="fill"
               [klevuTrackCategoryProductClick]="klevuCategoryProductTrackClick"
               [klevuTrackRecommendationsProductClick]="klevuRecommendationsProductClickData"
               [klevuTrackClick]="klevuSearchTrackClick">
                <div [gtmTrackProductClick]="gtmProductClick">
                    <local-shell />
                    <img class="fill"
                         [image]="getAlternativeImage()">
                </div>
            </a>
            @if (!hideLabels && (labels?.length || model.isNew)) {
            <div class="z-2 pos-absolute bottom-0 right-0">
                <!-- is new label -->
                @if (model.isNew) {

                <!-- in stock label -->
                @if (currentInStockLabel) {
                <span class="plp-label col-w s3 m-r-2"
                      [ngStyle]="{'background-color' : currentInStockLabel.color || 'black'}">
                    {{ currentInStockLabel.label }}
                </span>
                }
                <span class="bg-col-11 plp-label col-w s3">
                    {{ 'New In' | translate }}
                </span>
                }
                <!-- default label -->
                @if (!model.isNew) {
                @for (label of currentLabels; track label; let isFirst = $first) {
                <span class="plp-label col-w s3"
                      [class.m-l-2]="!isFirst"
                      [ngStyle]="{'background-color' : label.color || 'black'}">
                    {{label.label}}
                </span>
                }
                }
            </div>
            }
            @if(!hideWishlist) {
            <product-wishlist-toggle [productId]="wishlistId"
                                     (click)="$event.stopPropagation();$event.preventDefault()"
                                     class="pos-absolute z-4 top-2 right-2">
            </product-wishlist-toggle>
            }
            @if (model?.data?.promotion_banner) {
            <div [ngClass]="[
                       client.isS && gridSize === 2 ? 's3' : 'p-t-2 p-b-2 s1',
                       isBlackLabel ? 'bg-col-b' : 'bg-col-6'
                       ]"
                 class="pos-absolute center z-4 bottom-0 left-0 right-0 col-w _promotion-banner-copy"
                 [ngStyle]="client.isS && gridSize === 1 ? {'font-size': '1rem'} : {}">
                {{model.data.promotion_banner | optionLabel : 'promotion_banner'}}
            </div>
            }
        </div>
        }
    </div>
    @if (!hideDetails) {
    <a [routerLink]="url"
       [klevuTrackCategoryProductClick]="klevuCategoryProductTrackClick"
       [klevuTrackRecommendationsProductClick]="klevuRecommendationsProductClickData"
       [klevuTrackClick]="klevuSearchTrackClick"
       class="m-t-2 m-b-2  block">
        <div [gtmTrackProductClick]="gtmProductClick">
            @if (!hideBrandRange || showRangeCode) {
            @if (model.displayBrandCode && !showRangeCode) {
            <p class="col-11"
               [ngClass]="smallText ? 's2' : 's1'">{{model.brandCode | titlecase}}</p>
            }
            @if (model.displayRangeCode) {
            <p [ngClass]="smallText ? 's2' : 's1'">{{model.rangeCode | titlecase}}</p>
            }
            }
            @if (productOutline && !showRangeCode) {
            <p [ngClass]="smallText ? 'p2' : 'p1'">{{productOutline}}</p>
            }
        </div>
    </a>
    }

    <!-- reviews -->
    @if (showReviews && model.canDisplayReviews) {
    <div class="pos-relative">
        <reviews-io-rating class="m-b-2 block _product-reviews"
                           [product]="model"
                           [showRatingText]="false"></reviews-io-rating>
    </div>
    }

    @if(!hidePrice) {
    <div class="no-wrap flex flex-middle m-b-3">
        @if (displayFromPrice) {
        <span class="c1 col-12 m-r-1"
              translate>from</span>
        }
        @if (orgPrice) {
        <price class="p2 col-12 inline-block line-through va-m m-r-1"
               [value]="orgPrice"></price>
        }
        <price class="s2 inline-block"
               [ngClass]="orgPrice ? 'col-2' : 'col-1'"
               [value]="price"></price>
    </div>
    }
    @if (model.canShowMoreColourOptionsAvailableInfo) {
    <div class="p-t-3 col-12"
         [ngClass]="client.isS && gridSize === 2 ? 'c1' : 'p2'">
        {{'More colour options available'|translate}}
    </div>
    }

    @if(((isLastXRemainingBanner && isMaxQty && model.isClearanceOnline) || model.data.PLP_promo_banner &&
    !isLastXRemainingBanner) && !hideLastXRemainingBanner){
    <span class="s3 p-r-1 p-l-1 p-a-2-x p-a-2-l p-a-2-m _text-ellipsis-mobile"
          [ngStyle]="{ 'background-color': bannerBackgroundColor, 'color': (model.data.PLP_promo_banner | optionColor: 'PLP_promo_banner') }"
          style="border-radius: 6px;">
        {{ (isMaxQty && isLastXRemainingBanner && model.isClearanceOnline) ?
        (asString(model.data.PLP_promo_banner | optionLabel: 'PLP_promo_banner') | translate : maxQty) :
        model.data.PLP_promo_banner | optionLabel: 'PLP_promo_banner' }}
    </span>
    }

    @if (!hideSwatches) {
    @if (swatchMapItems?.length) {
    <div class="m-t-3 m-b flex flex-middle">
        <!-- swatch -->
        @for (swatch of swatchMapItems | slice : 0 : 4; track
        swatch; let isLast = $last; let isFirst = $first) {
        <span [optHref]="swatch.url"
              [klevuTrackCategoryProductClick]="klevuCategoryProductTrackClick"
              [klevuTrackRecommendationsProductClick]="klevuRecommendationsProductClickData"
              [klevuTrackClick]="klevuSearchTrackClick"
              [class.m-r-2]="!isLast"
              (mouseenter)="onSwatchMouseEnter(swatch)">
            <swatch [image]="swatch.img_swatch"
                    [attributeCode]="'config_colour'"
                    [value]="swatch.config_colour"
                    class="inline-block"
                    [selected]="currentSwatchMapItem === swatch"></swatch>
        </span>
        }
        @if (swatchMapItems?.length > 4)
        {
        <a [routerLink]="model.data.url"
           class="p2 col-12 m-l-1"
           [klevuTrackCategoryProductClick]="klevuCategoryProductTrackClick"
           [klevuTrackRecommendationsProductClick]="klevuRecommendationsProductClickData"
           [klevuTrackClick]="klevuSearchTrackClick">
            <span [gtmTrackProductClick]="gtmProductClick">
                +{{swatchMapItems.length - 4}}
            </span></a>
        }
    </div>
    }
    }
</div>
@if (quickAdd) {
<div class="flex flex-middle">
    <basket-item-qty [(model)]="selectedQty"
                     [max]="9999"
                     [min]="1"
                     class="inline-block qty-button m-r-2"
                     (modelChange)="detectChanges()"></basket-item-qty>
    <quick-add-to-basket class="flex-grow m-l-2 m-l-0-s"
                         [product]="addToBasketProduct"
                         [buyRequest]="request"
                         [qty]="selectedQty"
                         cy-ppAddToBasketButton></quick-add-to-basket>
</div>

}
}

}